/**
 * Omniture.js
 * For tracking events for preference center
 */

import Omniture from '@sfly/uig-omniture';
import { getBaseHostname } from '@sfly/uig-current-environment-util';

export class OmnitureUtil {
    // track if page loaded or not
    static trackPageLoad (name, type) {
        OmnitureUtil.reportOmniture(() => {
            OmnitureUtil.addSessioninfo();
            Omniture.putOmniture({
                page: {
                    pageInfo: {
                        pageName: name,
                        pageType: type
                    }
                }
            });
        });
    }

    /**
    * addSesionInfo()
    * add session details to DTL payload
    * needs to called for each event tracking
    */
    static addSessioninfo () {
        window.$omnitureDTL.loadOmnitureSession(
            location.origin,
            (session) => {
                try {
                    if (session.visitorDetails && session.visitorDetails.customerId === undefined) {
                        session.visitorDetails.customerId = '';
                    }

                    if (session.visitorDetails && !session.visitorDetails.regionName) {
                        session.visitorDetails.regionName =
                            window.localStorage.getItem("regionName") || "";
                    }
                    session.noClobber = true;
                    window.$omnitureDTL.processOmnitureJSPData(null);
                    window.$omnitureDTL.putOmnitureJSPData(location.origin, session);
                } catch (err) {
                    return err;
                }
            },
        );
    }

    /**
    * reportOmniture()
    * @param {func} callOmniture
    */
    static reportOmniture (callOmniture) {
        const isDTLEnabled = Omniture.isDTLEnabled();
        if (isDTLEnabled === true) {
            callOmniture();
        } else if (isDTLEnabled === undefined) {
            const appcodeHostname = getBaseHostname();
            Omniture.setupOmnitureTracking(`https://www.${appcodeHostname}`, (isDtlEnabled) => {
                if (isDtlEnabled === true) {
                    callOmniture();
                }
            });
        }
    }

    /**
     * @name putOmniture
     * @description
     * generic funtion to add data to omniture tracking.
     * `data` should be of JSON format only.
     * @param { data } putOmniture
     */
    static putOmniture (data) {
        const isDTLEnabled = Omniture.isDTLEnabled();
        if (isDTLEnabled === true) {
            Omniture.putOmniture(data);
        } else if (isDTLEnabled === undefined) {
            const appcodeHostname = getBaseHostname();
            Omniture.setupOmnitureTracking(`https://www.${appcodeHostname}`, (isDtlEnabled) => {
                if (isDtlEnabled === true) {
                    Omniture.putOmniture(data);
                }
            });
        }
    }
}
